module.exports = __webpack_public_path__ + "static/media/curve-4.01c4eaf4.svg";